/*global jQuery*/

(function ($) {
    "use strict";

    /**
     * Табы для слайдера событий на главной странице
     * @returns {jQuery}
     */
    $.fn.indexEventTabs = function () {
        var $self = $(this);
        var $tabs = $self.find(".js-index-event-category");
        var $content = $self.find(".js-index-event-content");

        /**
         * Установить активный таб по его индексу
         * @param {Number} index - индекс активируемого таба
         */
        var setActiveTab = function (index) {
            $tabs.removeClass("active").eq(index).addClass("active");
            $content.removeClass("active").eq(index).addClass("active");
            $self.trigger("setActiveTab");
        };

        /**
         * Инициализация
         */
        var init = function () {
            $tabs.on("click", function () {
                setActiveTab($(this).index());
            });

            setActiveTab(0);
        };

        init();

        // Публичные методы
        this.setActiveTab = setActiveTab;

        return this;
    };

    /**
     * Прокрутка календаря на главной странице
     * @returns {jQuery}
     */
    $.fn.indexEventSlider = function (swiperOptions = {}) {
        var self = $(this).get(0);
        var container = self.querySelector(".js-event-slider-container");
        var pagination = self.querySelector(".js-event-slider-dots");
        var arrPrev = self.querySelector(".js-event-slider-prev");
        var arrNext = self.querySelector(".js-event-slider-next");
        var btnDisabledClass = "disabled";
        var slidesPerView = 3;
        var sliderCount = $(self).find(".js-event-slider-items li").length;
        var slidesPerGroup = slidesPerView;
        // для слайдера с матчами
        // слайдер свайпается по 1 слайду
        var startIndexSlide = $(this).data("start-index");
        if (startIndexSlide) {
            slidesPerGroup = 1;
        }

        /**
         * Инициализация
         */
        var init = function () {
            var swiper = new Swiper(container, {
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                normalizeSlideIndex: false,
                slidesPerView: "auto",
                pagination: {
                    el: pagination,
                    type: "bullets",
                    clickable: true,
                    dynamicBullets: swiperOptions.pagination?.dynamicBullets,
                },
                breakpoints: {
                    1280: {
                        slidesPerView: slidesPerView,
                        slidesPerGroup: slidesPerGroup,
                    },
                },
                on: {
                    init: function (swiper) {
                        if (startIndexSlide) {
                            // для слайдера с матчами
                            // вначале пролистывается до активного
                            swiper.slideTo(startIndexSlide);
                        }
                    },
                    activeIndexChange: function (swiper) {
                        setSliderButtonsVisibility(swiper);
                    },
                },
            });

            if (sliderCount <= slidesPerView) {
                $(self).find(".js-event-slider-control").hide();
            }

            if (arrPrev && arrNext) {
                arrPrev.addEventListener("click", function () {
                    // swiper.slidePrev();
                    if (!swiper.isBeginning) {
                        swiper.slideTo(
                            swiper.activeIndex - swiper.params.slidesPerGroup
                        );
                    }
                });
                arrNext.addEventListener("click", function () {
                    // swiper.slideNext();
                    if (!swiper.isEnd) {
                        swiper.slideTo(
                            swiper.activeIndex + swiper.params.slidesPerGroup
                        );
                    }
                });
            }

            return swiper;
        };

        var setSliderButtonsVisibility = function (swiper) {
            if (arrNext && arrPrev) {
                arrPrev.classList.toggle(btnDisabledClass, swiper.isBeginning);
                arrNext.classList.toggle(btnDisabledClass, swiper.isEnd);
            }
        };

        const swiperInstance = init();
        $(this).data("swiper", swiperInstance);

        return this;
    };

    /**
     * Подгрузка новых будущих карточек
     * @returns {jQuery}
     */
    $.fn.indexEventUpdate = function (options = {}) {
        const $container = $(this);
        const swiper = $container.data("swiper") || options.swiper;
        const FIRST_OFFSET = $container.find(".js-match-main__time").length;

        if (!swiper) {
            console.warn("Swiper instance не найден");
            return;
        }

        const LIMIT = 10;
        const SLIDE_PRELOAD = 5;

        let currentPage = 0;
        let loadMatchesLength = 0;
        let initialLoadDone = false;
        let isLoading = false;

        swiper.on("slideChange", async () => {
            const currentIndex = swiper.activeIndex;
            const totalSlides = swiper.slides.length;
            const offset = currentPage * LIMIT + FIRST_OFFSET;

            const isNearEnd = currentIndex >= totalSlides - SLIDE_PRELOAD;
            const shouldLoad = !initialLoadDone || offset < loadMatchesLength;

            if (!isNearEnd || !shouldLoad || isLoading) return;

            isLoading = true;

            try {
                const params = new URLSearchParams({
                    limit: LIMIT,
                    offset,
                });

                const response = await fetch(
                    `/main-calendar/load-matches?${params}`
                );
                const data = await response.json();

                data.items.forEach((element) => {
                    swiper.appendSlide(element.content);
                });

                loadMatchesLength = data.count;
                currentPage += 1;
                initialLoadDone = true;
            } catch (e) {
                console.error("Ошибка загрузки матчей:", err);
            } finally {
                isLoading = false;
            }
        });

        return this;
    };
})(jQuery);
